const categoryItems = document.querySelectorAll<HTMLElement>('.i-category');

const mobileQuery = window.matchMedia("(max-width: 61.999em)")
categoryItems.forEach(item => {
  const toggle = item.querySelector<HTMLElement>('.i-category__toggle');

  const panel = item.querySelector<HTMLElement>('.main-header-mobile-panel');

  toggle?.addEventListener('click', () => {
    item.classList.toggle('--open');
    panel.classList.add('--open');
    if (mobileQuery.matches) document.body.classList.add('--disable-scroll');

    const parentPanel = item.closest('.main-header-mobile-panel');
    parentPanel?.scrollTo({top: 0})
    parentPanel?.classList.add('--child-open');
  })
})
